import api from '../../../mdms_api';

export default async (asset_uuid) => {
  const url = `/api/v1/cms/sites/${PB_SITE}/assets/${asset_uuid}`;
  const response = await api.get(url)
  return await response.json();
};
